export default __webpack_public_path__ + "static/media/qc_photo-1.069483b9.jpg";